

//COMMON action Types
export const TRANSPORT = 'TRANSPORT';
export const MESSAGE = 'MESSAGE';
export const SETSTATE = 'SETSTATE';
export const SELECT = 'SELECT';
export const DESELECT = 'DESELECT';
export const RESET_SELECTION = 'RESET_SELECTION';

//AppParameter action type
export const FETCH_LOCALITYS_DWK = 'FETCH_LOCALITYS_DWK';
export const FETCH_PROJECTNAMERESIS_DWK = 'FETCH_PROJECTNAMERESIS_DWK';
export const FETCH_PROJECTNAMECOMS_DWK = 'FETCH_PROJECTNAMECOMS_DWK';
export const FETCH_LOCALITYS_GGN = 'FETCH_LOCALITYS_GGN';
export const FETCH_PROJECTNAMERESIS_GGN = 'FETCH_PROJECTNAMERESIS_GGN';
export const FETCH_PROJECTNAMECOMS_GGN = 'FETCH_PROJECTNAMECOMS_GGN';

//review action Types 
export const SEARCH_REVIEWS = 'SEARCH_REVIEWS';
export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const FETCH_REVIEW = 'FETCH_REVIEW';
export const FETCHING_REVIEWS = 'FETCHING_REVIEWS';

//propOverView action Types
export const SEARCH_PROPOVERVIEWS = 'SEARCH_PROPOVERVIEWS';
export const FETCH_PROPOVERVIEWS = 'FETCH_PROPOVERVIEWS';
export const FETCH_PROPOVERVIEW = 'FETCH_PROPOVERVIEW';
export const FETCHING_PROPOVERVIEWS = 'FETCHING_PROPOVERVIEWS';

//review action Types
export const SEARCH_AWARDS = 'SEARCH_AWARDS';
export const FETCH_AWARDS = 'FETCH_AWARDS';
export const FETCH_AWARD = 'FETCH_AWARD';
export const FETCHING_AWARDS = 'FETCHING_AWARDS';

//Residential Project action types Dwarka
export const SEARCH_DWK_RESI_PROJECTS = 'SEARCH_DWK_RESI_PROJECTS';
export const FETCH_DWK_RESI_PROJECTS = 'FETCH_DWK_RESI_PROJECTS';
export const FETCH_DWK_RESI_PROJECT = 'FETCH_DWK_RESI_PROJECT';
export const UPDATE_DWK_RESI_PROJECT = 'UPDATE_DWK_RESI_PROJECT';
export const FETCHING_DWK_RESI_PROJECTS = 'FETCHING_DWK_RESI_PROJECTS';
//Residential Project action types Gurgaon
export const SEARCH_GGN_RESI_PROJECTS = 'SEARCH_GGN_RESI_PROJECTS';
export const FETCH_GGN_RESI_PROJECTS = 'FETCH_GGN_RESI_PROJECTS';
export const FETCH_GGN_RESI_PROJECT = 'FETCH_GGN_RESI_PROJECT';
export const UPDATE_GGN_RESI_PROJECT = 'UPDATE_GGN_RESI_PROJECT';
export const FETCHING_GGN_RESI_PROJECTS = 'FETCHING_GGN_RESI_PROJECTS';
//******************
//Commercial Project action types  Dwarka

export const SEARCH_DWK_COM_PROJECTS = 'SEARCH_DWK_COM_PROJECTS';
export const FETCH_DWK_COM_PROJECTS = 'FETCH_DWK_COM_PROJECTS';
export const FETCH_DWK_COM_PROJECT = 'FETCH_DWK_COM_PROJECT';
export const UPDATE_DWK_COM_PROJECT = 'UPDATE_DWK_COM_PROJECT';
export const FETCHING_DWK_COM_PROJECTS = 'FETCHING_DWK_COM_PROJECTS';
//Commercial Project action types  Gurgaon

export const SEARCH_GGN_COM_PROJECTS = 'SEARCH_GGN_COM_PROJECTS';
export const FETCH_GGN_COM_PROJECTS = 'FETCH_GGN_COM_PROJECTS';
export const FETCH_GGN_COM_PROJECT = 'FETCH_GGN_COM_PROJECT';
export const UPDATE_GGN_COM_PROJECT = 'UPDATE_GGN_COM_PROJECT';
export const FETCHING_GGN_COM_PROJECTS = 'FETCHING_GGN_COM_PROJECTS';
//Residential Property action types Dwarka
export const SEARCH_DWK_PROPRESIS = 'SEARCH_DWK_PROPRESIS';
export const FETCH_DWK_PROPRESIS = 'FETCH_DWK_PROPRESIS';
export const FETCH_DWK_PROPRESI = 'FETCH_DWK_PROPRESI';
export const UPDATE_DWK_PROPRESI = 'UPDATE_DWK_PROPRESI';
export const FETCHING_DWK_PROPRESIS = 'FETCHING_DWK_PROPRESIS';

//Residential Property action types Gurgaon
export const SEARCH_GGN_PROPRESIS = 'SEARCH_GGN_PROPRESIS';
export const FETCH_GGN_PROPRESIS = 'FETCH_GGN_PROPRESIS';
export const FETCH_GGN_PROPRESI = 'FETCH_GGN_PROPRESI';
export const UPDATE_GGN_PROPRESI = 'UPDATE_GGN_PROPRESI';
export const FETCHING_GGN_PROPRESIS = 'FETCHING_GGN_PROPRESIS';
//******************
//Commercial Property action types Dwarka
export const SEARCH_DWK_PROPCOMS = 'SEARCH_DWK_PROPCOMS'; 
export const FETCH_DWK_PROPCOMS = 'FETCH_DWK_PROPCOMS';
export const FETCH_DWK_PROPCOM = 'FETCH_DWK_PROPCOM';
export const UPDATE_DWK_PROPCOM = 'UPDATE_DWK_PROPCOM';
export const FETCHING_DWK_PROPCOMS = 'FETCHING_DWK_PROPCOMS';

//Commercial Property action types Gurgaon
export const SEARCH_GGN_PROPCOMS = 'SEARCH_GGN_PROPCOMS'; 
export const FETCH_GGN_PROPCOMS = 'FETCH_GGN_PROPCOMS';
export const FETCH_GGN_PROPCOM = 'FETCH_GGN_PROPCOM';
export const UPDATE_GGN_PROPCOM = 'UPDATE_GGN_PROPCOM';
export const FETCHING_GGN_PROPCOMS = 'FETCHING_GGN_PROPCOMS';

//ContactUs action types
export const SEARCH_CONTACTUSS = 'SEARCH_CONTACTUSS';
export const SELECT_CONTACTUS = 'SELECT_CONTACTUS';
export const DESELECT_CONTACTUS = 'DESELECT_CONTACTUS';
export const FETCH_CONTACTUSS = 'FETCH_CONTACTUSS';
export const FETCH_CONTACTUS = 'FETCH_CONTACTUS';
export const FETCHING_CONTACTUSS = 'FETCHING_CONTACTUSS';


export const CREATE_ERROR = 'CREATE_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';

//###################################
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_ERRORS = 'GET_ERRORS';
//##################################,
// user action types
export const SEARCH_USERS = 'SEARCH_USERS';
export const CREATE_USERS = 'CREATE_USERS';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USERDETAIL = 'FETCH_USERDETAIL';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';

// modal action types
export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_CLOSE = 'MODAL_CLOSE';
export const FETCHING = 'FETCHING';
// popup action types
export const POPUP_OPEN = 'POPUP_OPEN'; 
export const POPUP_CLOSE = 'POPUP_CLOSE';
// sidebar action types
export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const HIDE_SIDEBAR = 'HIDE_SIDEBAR';
// Backbutton action types
export const SHOW_BACKBUTTON = 'SHOW_BACKBUTTON';
export const HIDE_BACKBUTTON = 'HIDE_BACKBUTTON';

//NOTIFICATION action Types
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const FETCH_NOTIFICATION = 'FETCH_NOTIFICATION';
export const FETCHING_NOTIFICATIONS = 'FETCHING_NOTIFICATIONS';
